import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError, LOGO_URL } from "@/lib/api";
import { toast, Toaster } from "sonner";

export default function Login() {
  const { login, startGoogle } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, pw);
      toast.success("Welcome back!");
      if (u.role === "admin") nav("/admin");
      else if (u.role === "employer") nav("/employer");
      else nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="nh-container py-14 grid md:grid-cols-2 gap-10 items-start">
      <Toaster position="top-center"/>
      <div className="hidden md:block">
        <img src={LOGO_URL} alt="NextHire" className="h-24 w-24 rounded-xl border-2 border-black object-cover"/>
        <h1 className="font-display font-black text-5xl mt-6">Welcome back. Let's find your <span className="bg-[var(--nh-accent)] px-2 border-2 border-black rounded-md">next hire</span>.</h1>
        <p className="text-[var(--nh-muted)] mt-4 max-w-md">Sign in to apply to jobs, track applications, and build your resume.</p>
      </div>
      <div className="nh-card p-8">
        <h2 className="font-display font-black text-3xl">Log in</h2>
        <button onClick={()=>startGoogle("youth")} className="nh-btn nh-btn-ghost w-full mt-6" data-testid="login-google">
          <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.09-1.93 3.27-4.77 3.27-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18A11 11 0 0 0 1 12c0 1.77.42 3.44 1.18 4.94l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          Continue with Google
        </button>
        <div className="my-5 flex items-center gap-3 text-xs uppercase text-[var(--nh-muted)]">
          <div className="flex-1 h-px bg-black/20"/>or<div className="flex-1 h-px bg-black/20"/>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="text-xs font-bold uppercase">Email</label>
            <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="nh-input mt-1" data-testid="login-email"/>
          </div>
          <div>
            <label className="text-xs font-bold uppercase">Password</label>
            <input type="password" required value={pw} onChange={(e)=>setPw(e.target.value)} className="nh-input mt-1" data-testid="login-password"/>
          </div>
          <button disabled={loading} className="nh-btn nh-btn-primary w-full" data-testid="login-submit">
            {loading ? "Signing in…" : "Log in"}
          </button>
        </form>
        <p className="text-sm mt-5">
          Don’t have an account? <Link to="/signup" className="font-bold underline" data-testid="link-signup">Sign up</Link>
        </p>
      </div>
    </div>
  );
}
